import {UPDATE_MIGRATION_ENTITY, CLEAR_MIGRATION_ENTITY} from '../../action.types'
const initialState = {
    entity: {}
}

const _update = (state, migrationEntity) => {
    return {
        entity: {
            ...state.entity,
            ...migrationEntity
        }
    }
}

export default (state = initialState, action) => {
    switch(action.type){
        case UPDATE_MIGRATION_ENTITY:
            return _update(state, action.payload)
        case CLEAR_MIGRATION_ENTITY:
            return initialState
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/js/reducers/migration-entity/migration.entity.reducer.js